<script context="module">
  import { l } from "$lib/Utils/l10n.svelte";

  export let userMenuItems = [
    {
      id: "user",
      icon: "user",
      title: l("Informatie"),
      top: true,
      action: "show-user",
      description: "",
    },
    {
      id: "refresh",
      icon: "rotate",
      title: l("Verversen"),
      action: "refresh",
      description: l("Herstart de applicatie"),
    },
    {
      id: "logout",
      icon: "sign-out-alt",
      title: l("Afmelden"),
      action: "logout",
      description: l("Afmelden"),
    },
    {
      id: "about",
      icon: "circle-info",
      title: l("Over ZORG-AB"),
      action: "show-info",
      description: l("Het zorg adresboek"),
    },
    {
      id: "privacyverklaring",
      icon: "blinds",
      title: l("Privacyverklaring"),
      action: "show-info",
      description: l("Diensten en uw rechten"),
    },
    {
      id: "terms-of-service",
      icon: "id-card-clip",
      title: l("Servicevoorwaarden"),
      action: "show-info",
      description: l("voorwaarden voor gebruik"),
    },
    {
      id: "version",
      icon: "code-branch",
      title: l("Versie ZORG-AB Webportaal"),
      action: "show-user",
      description: l("Versie informatie"),
    },
  ];

  export let dashboardActions = [];

  export let startActions = [
    {
      id: "search",
      icon: "glasses",
      title: "Zoeken",
      tooltip: "zoeken gegevens zorgaanbieders en zorgverleners",
      elucidation: "zoeken gegevens zorgaanbieders en zorgverleners",
      action: "search",
    },
    {
      id: "edit",
      icon: "building-user",
      title: "Eigen gegevens",
      tooltip: "inzien en beheren eigen gegevens",
      elucidation: "inzien en beheren eigen gegevens",
      action: "edit",
    },
  ];
</script>
